import './App.css';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from "./components/pages/Home";
import Contact from "./components/pages/Contact";
import Kajaria from "./components/pages/Kajaria";
import Dulux from "./components/pages/Dulux";
import Coto from "./components/pages/Coto";
import SomanyPage from "./components/pages/SomanyPage";
import Orientbell from "./components/pages/Orientbell";
import Pinolex from "./components/pages/Pinolex";

import Johnson from "./components/pages/Johnson";
import KajariaKitchenwall from "./components/pages/KajariaKitchenwall";
import Footer from "./components/inc/Footer";
import WatertecPage from './components/pages/WatertecPage';
import KajariaNouvellapage from './components/pages/KajariaNouvellapage';
import KajariaNouvella60X120 from './components/pages/KajariaNouvella60X120';
import JaquarProductpage from './components/pages/JaquarProductpage';

function App() {
  return (
    
    <Router>
      
  
     
        <div>
      
         
          
          <Routes>
     
         
          <Route axact path="/" element={<Home/>}/>
          <Route axact path="/Kajaria" element={<Kajaria/>}/>
      
          <Route axact path="/coto" element={<Coto/>}/>

          <Route axact path="/Somany" element={<SomanyPage/>}/>
          <Route axact path="/Dulux" element={<Dulux/>}/>
        
          <Route axact path="/Johnson" element={<Johnson/>}/>
          <Route axact path="/Finolex" element={<Pinolex/>}/>
          <Route axact path="/Orientbell" element={<Orientbell/>}/>
          <Route axact path="/KajariaKitchenwall" element={<KajariaKitchenwall/>}/>
          <Route axact path="/Contact" element={<Contact/>}/>
           <Route axact path="/Watertec" element={<WatertecPage/>}/>
                      <Route axact path="/Jaquar" element={<JaquarProductpage/>}/>

            <Route axact path="/KajariaNouvelle" element={<KajariaNouvellapage/>}/>
              <Route axact path="/KajariaNouvella60X120cm" element={<KajariaNouvella60X120/>}/>
          
          </Routes>
    <Footer/>
  
    </div>

    </Router>
   
       );
}

export default App;
